export const LOCAL_STORAGE_KEYS = {
  purchaseHistory: "XD2SKETCH.purchaseHistory",
  userDetails: "XD2SKETCH.userDetails",
  fileDetails: "XD2SKETCH.fileDetails",

  trialUsed: "XD2SKETCH.trialUsed",
  uploadedFileName: "XD2SKETCH.uploadedFileName",
};
